/**
 * @file PositionsComposition.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React, { useState, useEffect } from "react";
import Widget from "../Widget";

function PositionsComposition({ width, data, loading }) {
  const [positionsData, setPositionsData] = useState([]);

  useEffect(() => {
    if (data) {
      setPositionsData(data);
    }
  }, [data]);

  return (
    <Widget name={"positions-gain-loss"} width={"full-width"}>
      <div className="heading">
        <h1 className="title">Positions Composition</h1>
        <table className="basic-table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Cost basis</th>
              <th>Qty</th>
            </tr>
          </thead>
          <tbody>
            {positionsData?.map((position) => (
              <tr key={position.id}>
                <td className="symbol">
                  <p className="order-text">{position.symbol}</p>
                </td>
                <td className="cost-basis">
                  <p className="order-text">${position.cost_basis}</p>
                </td>
                <td className="qty">
                  <p className="order-text">{position.quantity}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Widget>
  );
}

export default PositionsComposition;
